import { Controller } from '@hotwired/stimulus'
import i18n from '../javascripts/util/i18n'

// Show/hide toggle for a password input. Flips the field between
// type="password" and type="text" and swaps either an eye icon (profile) or a
// text label (sign-in / sign-up "Show"/"Hide" buttons). The label's two strings
// come from data-show-label / data-hide-label so callers can localize them.
export default class extends Controller {
  static targets = ['input', 'icon', 'label']

  toggle() {
    const reveal = this.inputTarget.type === 'password'
    this.inputTarget.type = reveal ? 'text' : 'password'

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('fa-eye', !reveal)
      this.iconTarget.classList.toggle('fa-eye-slash', reveal)
    }

    if (this.hasLabelTarget) {
      const { showLabel = i18n.t('js.common.show'), hideLabel = i18n.t('js.common.hide') } = this.labelTarget.dataset
      this.labelTarget.textContent = reveal ? hideLabel : showLabel
    }
  }
}
